import { COLORS, TYPOGRAPHY } from '@app/constants';
import { FC } from 'react';
import { components, OptionProps } from 'react-select';
import styled, { css } from 'styled-components';
import Checkbox from '@app/ui/components/Checkbox';

const Option: FC<OptionProps> = ({ children, ...props }) => {
  return (
    <Root $isMulti={props.isMulti} $isFocused={props.isFocused}>
      <components.Option {...props}>
        <Background $shouldHighlight={!props.isMulti && props.isSelected}>
          {props.isMulti ? (
            <StyledCheckbox
              readOnly
              checked={props.isSelected}
              id={`${props.innerProps.id}`}
              text={children}
              isFocused={props.isFocused}
            />
          ) : (
            children
          )}
        </Background>
      </components.Option>
    </Root>
  );
};

export default Option;

interface RootStyleProps {
  $isMulti: boolean;
  $isFocused: boolean;
}

interface BackgroundStyleProps {
  $shouldHighlight: boolean;
}

const Background = styled.div<BackgroundStyleProps>`
  width: 100%;
  cursor: pointer;

  ${({ $shouldHighlight }) =>
    $shouldHighlight
      ? css`
          background-color: ${COLORS.primary50};
        `
      : css`
          background-color: transparent;

          &:hover {
            background-color: ${COLORS.primary50};
          }
        `};
`;

const Root = styled.li<RootStyleProps>`
  &:not(:last-child) {
    margin-bottom: 8px;
  }

  & > div {
    display: flex;
    width: 100%;
    user-select: none;
  }

  & ${Background} {
    ${({ $isMulti }) =>
      $isMulti
        ? css`
            & label {
              padding: 6px 16px;
              width: inherit;
            }
          `
        : css`
            padding: 6px 16px;
          `};
    background-color: ${({ $isFocused }) =>
      $isFocused ? COLORS.primary50 : 'transparent'};
  }
`;

const StyledCheckbox = styled(Checkbox)`
  ${TYPOGRAPHY.body1Regular14}
  color: ${COLORS.grayscale700};
`;
